module.exports = __webpack_public_path__ + "bec7c629e0b8f391a64f7e2ed4e57516.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/main/assets/images/orca-logo.png
 ** module id = 10
 ** module chunks = 0
 **/